import { FieldValue, FormState } from "./Form.types";

export const isEqualFormState = <T extends FieldValue>(state1: FormState<T>, state2: FormState<T>): boolean => {
  const keys1 = Object.keys(state1);
  const keys2 = Object.keys(state2);

  if (keys1.length !== keys2.length) {
      return false;
  }

  return keys1.every(key => state1[key] === state2[key]);
};